import groq from 'groq';

import { ASSET, CLOUDINARY_VIDEO } from '../common';

export const PRODUCT_MEDIA = groq`
  _type,
  _type == "image" => {
    ${ASSET},
  },
  _type == "gif" => {
    ${CLOUDINARY_VIDEO},
  },
  _type == "video" => {
    ${CLOUDINARY_VIDEO},
    poster {
      ${ASSET},
    },
  }
`;

export const PRODUCT_MEDIA_FULL_LIST = groq`
  images[] {
    ${PRODUCT_MEDIA}
  }
`;
export const PRODUCT_MEDIA_FIRST_TWO = groq`
  images[0..1] {
    ${PRODUCT_MEDIA}
  }
`;
